<template>
  <div>
    <div :style="'padding-bottom: 50px;background-color:#FFA300'">
      <v-row class="pa-3 pb-0">
        <div @click="$router.go(-1)" style="font-size: 20px;padding:15px;" :style="`color: ${$CUSTOMMainTextColor}`"> <v-icon>mdi-chevron-left</v-icon>{{ $t("message.myReward") }}</div>
        <div style="align-items: center;display: flex;">
          <img
          v-if="profile && profile.pictureUrl"
          style="
            border-color: white;
            height: 20px;
          "
          alt="Avatar"
          :src="$images.ChubbGift"
          />
        </div>
      </v-row>
        <v-row justify="center" class="mt-3 pt-2" stlye="">
          <v-col cols="4" align="center" class="pa-2" style="font-size:15px;background-color:#ffff;box-shadow: 0px 1px 1px 0px #00000040;">
            {{ $t("message.myReward") }}
          <v-col align="center" class="pa-0" :style="'font-weight: bold;font-size:20px;color:' + $CUSTOMMainTextColor" v-if="notExpire > 0">{{notExpire}}</v-col>
          <v-col align="center" class="pa-0" :style="'font-weight: bold;font-size:20px;color:' + $CUSTOMMainTextColor" v-else>0</v-col>
        </v-col>
         <v-col cols="4" align="center" class="pa-2" style="font-size:15px;background-color:#ffff;box-shadow: 0px 1px 1px 0px #00000040;">
            {{ $t("message.expireReward") }}
          <v-col align="center" :style="'font-weight: bold;font-size:20px;color:' + $CUSTOMMainTextColor" class="pa-0" v-if="expire > 0">{{ expire }}</v-col>
          <v-col align="center" :style="'font-weight: bold;font-size:20px;color:' + $CUSTOMMainTextColor" class="pa-0" v-if="expire <= 0">{{ expire }}</v-col>
        </v-col>
        </v-row>
    </div>
    <div>
      <template style="padding-top:10px">
      <v-tabs v-model="tab" dark :background-color="levelById.color">
        <v-tabs-slider :color="HEXToVBColorLMG(levelById.color)"></v-tabs-slider>
        <v-tab href="#tab-1" :style="'color:' + HEXToVBColorLMG(levelById.color)"> {{ $t("message.myReward") }} </v-tab>
        <v-tab href="#tab-3" :style="'color:' + HEXToVBColorLMG(levelById.color)" v-if="shopId === 'SD_1737957295593'"> ของรางวัลจากแพ็กเกจ </v-tab>
        <v-tab href="#tab-2" :style="'color:' + HEXToVBColorLMG(levelById.color)"> {{ $t("message.expireReward") }} </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" style="background-color: #F2F2F2; min-height: 67vh;padding:13px;box-sizing: border-box;display: flex;flex-direction: column;">
        <v-tab-item :value="'tab-1'" v-if="items">
          <v-card
            v-if="item.supply === 'รับหน้าร้าน' || item.supply === 'Discount' || item.supply === 'coupon'"
            :elevation="$isTargetShop ? 0 : 1"
            v-for="(item, i) in myReward"
            :key="i"
            class="mb-0 mt-5"
            height="auto"
            flat
            title
            :style="$isTargetShop? 'border-radius: 0px!important':'box-shadow: 0px 4px 4px 0px #00000040;padding:15px;border-radius: 20px;border: solid ' + $colorSub"
          >
            <v-row>
              <v-col cols="4" style="padding-top:10px;" align="center">
                <img :src="item.pictureUrl" :style="$isTargetShop? 'width: 85px; height: 85px;border-radius: 0px;border-style: solid;border-color: #eeee;':'width: 85px; height: 85px;border-radius: 25px;border-style: solid;border-color: #eeee;'" class="link"/>
              </v-col>
              <v-col cols="8" class="pl-3 pr-3" >
                 <div class="font16 bold mt-1">
                  <v-col v-if="item.supply === 'coupon'" class="pa-0 mb-2">{{ item.remark }}</v-col>
                  <v-col v-else class="pa-0 mb-2">{{ item.name }}</v-col>
                  <v-col class="pl-0 pt-0 pb-0 mb-2 font12 icon2">{{ item.endDate ? $t("message.useBefor") : $t("message.notHaveExpire")}} {{ item.endDate ?  $i18n.locale === 'th' ? format_date_thai(item.endDate.split(' ').slice(0, -1)) : format_date(item.endDate.split(' ').slice(0, -1)).split(' ')[0] : ''}}</v-col>
                  <v-col class="pl-0 pt-0 pb-0 mb-2 font12 icon2" style="color: red !important;" v-if="shopId === shopNameData.bpv && new Date(today).getTime() > new Date(item.BvpExpieTime).getTime() &&  item.BvpExpieTime !== null">{{ $t("message.timeOutGetReward") }}</v-col>
                  <v-col class="pl-0 pt-0 pb-0 mb-2 font12 icon2" style="color: green !important;" v-if="shopId === shopNameData.bpv && new Date(today).getTime() < new Date(item.BvpExpieTime).getTime() &&  item.BvpExpieTime !== null">{{ $t("message.plsGetRewardIn") }} {{ item.BvpExpieMinAfterUse }} {{ $t("message.min") }}</v-col>
                  <v-col class="pa-0 pr-3" v-if="item.supply !== 'Discount'">
                    <!-- {{ format_date(today) > format_date(item.BvpExpieTim) }} -->
                    <!-- {{ new Date(today).getTime() < new Date(item.BvpExpieTim).getTime() }} -->
                    <v-btn
                        v-if="
                        new Date(momenDate_1(item.endDate)).getTime() >
                        today.getTime() && item.redeemStatus === 'get' && item.supply !== 'coupon'
                        "
                        :color="$bgColor"
                        flat
                        title
                        small
                        elevation="0"
                        :class="['w-100', 'ma-0', $isTargetShop ? '' : 'bold']"
                        block
                        :style="(isTargetShop ? 'color:#000;border-radius:0px!important' : 'color:white')"
                        :disabled="shopId === shopNameData.bpv && new Date(today).getTime() > new Date(item.BvpExpieTime).getTime() &&  item.BvpExpieTime !== null"
                        @click="useReward(item)"
                        >{{ item.rewardId === 338 ? 'ยืนยันสิทธิ์' : $t("message.useReward") }}</v-btn>
                        <v-btn
                        v-if="
                        item.supply === 'coupon'
                        "
                        :color="$bgColor"
                        flat
                        title
                        small
                        elevation="0"
                        :class="['w-100', 'ma-0', $isTargetShop ? '' : 'bold']"
                        block
                        :style="(isTargetShop ? 'color:#000;border-radius:0px!important' : 'color:white')"
                        @click="useReward(item)"
                        >{{ item.rewardId === 338 ? 'ยืนยันสิทธิ์' : $t("message.useReward") }}</v-btn>
                      <v-btn
                        v-if="
                        new Date(momenDate_1(item.endDate)).getTime() >
                        today.getTime() && item.redeemStatus === 'use'
                      "
                      :color="$bgColor"
                      flat
                      title
                      x-small
                      elevation="0"
                      :class="['w-100', 'ma-0', $isTargetShop ? '' : 'bold']"
                      block
                      disabled
                      :style="(isTargetShop ? 'color:#000;border-radius:0px!important' : 'color:white')"
                      @click="useReward(item)"
                      >{{ $t("message.received") }}</v-btn>
                  </v-col>
                  <v-col class="pa-0 pr-3" v-if="item.supply === 'Discount'">
                    <v-btn
                        v-if="item.endDate &&
                        new Date(momenDate_1(item.endDate)).getTime() >
                        today.getTime() && item.redeemStatus === 'get'
                      "
                      :color="$bgColor"
                      flat
                      title
                      small
                      elevation="0"
                      :class="['w-100', 'ma-0', $isTargetShop ? '' : 'bold']"
                      block
                      :style="(isTargetShop ? 'color:#000;border-radius:0px!important' : 'color:white')"
                      ><v-icon></v-icon>{{ 'โชว์ส่วนลดนี้ให้พนักงาน' }}</v-btn>
                      <v-btn
                        v-else
                      :color="$bgColor"
                      flat
                      title
                      small
                      elevation="0"
                      :class="['w-100', 'ma-0', $isTargetShop ? '' : 'bold']"
                      block
                      :style="(isTargetShop ? 'color:#000' : 'color:white')"
                      ><v-icon></v-icon>{{ 'โชว์ส่วนลดนี้ให้พนักงาน' }}</v-btn>
                  </v-col>
                </div>
              </v-col>
            </v-row>
          </v-card>
          <v-card
            v-if="item.supply !== 'รับหน้าร้าน' && item.supply !== 'Discount'"
            elevation="1"
            v-for="(item, i) in items.filter(
              (a) =>
                new Date(momenDate_1(a.endDate)).getTime() > today.getTime()
            )"
            :key="i"
            flat
            title
            class="mb-0 mt-5"
            height="auto"
            :style="$isTargetShop? 'border-radius: 0px!important':'box-shadow: 0px 4px 4px 0px #00000040;padding:15px;border-radius: 20px;border: solid ' + $colorSub2"
          >
          <v-col cols="12" style="padding-top: 10px" align="center">
                <img
                  :src="item.pictureUrl"
                  :style="$isTargetShop? 'width: 95px; height: 95px;border-radius: 0px;border-style: solid;border-color: #eeee;':'width: 95px; height: 95px;border-radius: 20px;border-style: solid;border-color: #eeee;'"
                  class="link"
                />
              </v-col>
              <v-col cols="12" class="pl-0 pr-0">
                <div class="font16 bold mt-1">
                  <v-col cols="12"
                  align="center" class="pa-0 mb-1">{{ item.name }}</v-col>
                  <v-col class="pa-0 mb-1" v-if="item.supply === 'จัดส่ง'"
                    >{{ $t("message.type") }}: <v-icon>mdi-cube-send</v-icon>
                    {{ item.supply }}</v-col
                  >
                  <v-col cols="12"
                  align="center" class="pa-0 mb-2" v-if="item.supply === 'จัดส่ง'"
                    >{{ $t("message.deliveryLocation") }}: {{ item.houseNumber }}, ต.{{
                      item.subDistrict
                    }}. อ.{{ item.district }}. จ.{{ item.provinces }}.
                    {{ item.postalCode }}</v-col
                  >
                   <v-col cols="12"
                  align="center" class="pa-0 mb-2" v-if="item.supply === 'จัดส่ง' && item.parcelNumber"
                    >{{ $t("message.parcelNumber") }}: {{ item.parcelNumber }}
                  </v-col
                  >
                  <v-col cols="12"
                  align="center" class="pa-0 mb-2" v-if="item.supply === 'จัดส่ง' && item.Transport"
                    >{{ $t("message.transportationService") }}: {{ item.Transport }}
                  </v-col
                  >
                  <v-col cols="12"
                  align="center" class="pa-0 mb-2" v-if="item.supply === 'link_code' && item.parcelNumber !== null"
                    >{{ $t("message.type") }}:
                    <v-icon>mdi-barcode-scan</v-icon>
                    {{ $t("message.linkcode") }}</v-col
                  >
                  <v-col
                  cols="12"
                  align="center"
                    v-if="
                      item.supply === 'link_code' &&
                      !item.rewardCode.startsWith('http') && item.rewardCode.search('/') === -1
                    "
                  >
                    <v-text-field
                      v-model="item.rewardCode"
                      :append-icon="
                        item.rewardCode ? 'mdi-content-copy' : 'mdi-copy'
                      "
                      ref="textToCopy"
                      outlined
                      style="width: 220px"
                      dense
                      hide-details
                      @click:append="copyText()"
                    ></v-text-field>
                  </v-col>
                  <v-col
                   cols="12"
                   align="center"
                    v-if="
                      item.supply === 'link_code' &&
                      !item.rewardCode.startsWith('http') && item.rewardCode.search('/') !== -1
                    "
                  >
                    <v-text-field
                      v-model="item.rewardCode.split('/')[0]"
                      :append-icon="
                        item.rewardCode ? 'mdi-content-copy' : 'mdi-copy'
                      "
                      ref="textToCopy"
                      outlined
                      style="width: 220px"
                      dense
                      hide-details
                      @click:append="copyText()"
                    ></v-text-field>
                    <v-text-field
                      v-model="item.rewardCode.split('/')[1]"
                      :append-icon="
                        item.rewardCode ? 'mdi-content-copy' : 'mdi-copy'
                      "
                      ref="textToCopy"
                      outlined
                      style="width: 220px"
                      dense
                      hide-details
                      @click:append="copyText()"
                    ></v-text-field>
                  </v-col>
                  <v-col
                  cols="12"
                  align="center"
                    class="pa-0 mb-2"
                    v-if="
                      item.supply === 'link_code' &&
                      item.rewardCode.startsWith('http')
                    "
                    ><a :href="item.rewardCode"
                      >*{{ item.rewardCode }}</a
                    ></v-col
                  >
                  <v-col
                    class="pa-0 mb-2"
                    v-if="
                      item.supply === 'link_code' &&
                      item.rewardCode.startsWith('http')
                    "
                    >กดลิงก์ด้านบนเพื่อรับของรางวัล</v-col
                  >
                  <v-col
                    class="pa-0 mb-1"
                    v-if="item.supply === 'รับหน้าร้าน' || item.supply === null"
                    >{{ $t("message.type") }}:
                    <v-icon class="pb-1">mdi-store</v-icon>{{ item.shopId === 'U2ad4ca7a5c84fbe7358b56f54af919fa' ? 'รับที่สำนักงานโครงการ' : $t("message.ReceiveAtStore") }}</v-col
                  >
                  <v-col cols="12"
                  align="center" class="pl-0 pt-0 pb-1 font16 icon2 mb-1" v-if="item.useDate !== null"
                    >{{ $t("message.redeemDate") }}: {{ $i18n.locale === 'th' && item.useDate !== null ? format_date_thai(item.useDate.split(' ').slice(0, -1)) : format_date(item.useDate.split(' ').slice(0, -1)).split(' ')[0] }}
                    <div class="pa-0 mt-1" v-if="item.supply === 'link_code'">
                    <v-icon color="green">mdi-check</v-icon>
                    <v-chip small color="green" dark>{{ $t("message.received") }}</v-chip></div
                  >
                  </v-col
                  >
                  <v-col
                    class="pa-0 icon2 mt-1"
                    v-if="
                      item.supply === 'จัดส่ง' && item.sendStatus === 'รอจัดส่ง'
                    "
                    ><v-chip small color="red" dark> {{ $t("message.waitDelivery") }}</v-chip></v-col
                  >
                  <v-col
                    class="pa-0 icon2 mt-1"
                    v-if="
                      item.supply === 'จัดส่ง' && item.sendStatus !== 'รอจัดส่ง'
                    "
                    ><v-icon color="green">mdi-check</v-icon
                    ><v-chip small color="green" dark>{{ $t("message.alreadyShip") }}</v-chip></v-col
                  >
                </div>
              </v-col>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'tab-2'" v-if="items">
           <v-card
            elevation="1"
            v-for="(item, i) in items.filter(
              (a) =>
                new Date(momenDate_1(a.endDate)).getTime() < today.getTime()
            )"
            :key="i"
            class="mb-0 mt-5"
            height="auto"
            :style="'box-shadow: 0px 4px 4px 0px #00000040;padding:15px;border-radius: 20px;border: solid ' + $colorSub2"
          >
            <v-row>
              <v-col cols="4" style="padding-top:10px;" align="center">
                <img :src="item.pictureUrl" style="width: 85px; height: 85px;border-radius: 25px;border-style: solid;border-color: #eeee;" class="link"/>
              </v-col>
              <v-col cols="8" class="pl-3 pr-0">
                 <div class="font16 bold mt-1">
                  <v-col class="pa-0 mb-2">{{ item.name }}</v-col>
                  <v-col class="pl-0 pt-0 pb-0 mb-2 font12 icon2">{{ $t("message.useBefor") }} {{ $i18n.locale === 'th' ? format_date_thai(item.endDate.split(' ').slice(0, -1)) : format_date(item.endDate.split(' ').slice(0, -1)).split(' ')[0] }}</v-col>
                    <v-btn
                      color="red"
                      small
                      elevation="0"
                      block
                      :class="['w-100', 'ma-0', $isTargetShop ? '' : 'bold']"
                      :style="(isTargetShop ? 'color:#000;border-radius:0px!important' : 'color:white')"
                      >หมดอายุแล้ว</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'tab-3'" v-if="groupedData && shopId === 'SD_1737957295593'">
          <v-card
            elevation="1"
            v-for="(item, i) in groupedData"
            :key="i"
            class="mb-0 mt-5"
            height="auto"
            :style="'box-shadow: 0px 4px 4px 0px #00000040;padding:15px;border-radius: 20px;border: solid ' + $colorSub2"
          >
              <!-- <v-col cols="4" style="padding-top:10px;" align="center">
                <img :src="item.pictureUrl" style="width: 85px; height: 85px;border-radius: 25px;border-style: solid;border-color: #eeee;" class="link"/>
              </v-col> -->
              <v-col cols="12" class="pl-0 pr-0 pt-0" >
                 <div class="font16 bold mt-1">

                  <v-col class="pa-0 mb-2"><img style=" border-color: white;height: 27px;margin-right: 3px;" :src="require('@/assets/package.png')"/>{{ item.packageName }}</v-col>
                  <v-card
                    elevation="1"
                    v-for="(item2, i) in item.rewards"
                    :key="i"
                    class="mb-0 mt-5"
                    height="auto"
                    :style="'box-shadow: 0px 4px 4px 0px #00000040;padding:15px;border-radius: 20px;border: solid ' + $colorSub2"
                  >
                    <v-row>
                      <v-col cols="4" style="padding-top:10px;" align="center">
                        <img :src="item2.pictureUrl" style="width: 85px; height: 85px;border-radius: 25px;border-style: solid;border-color: #eeee;" class="link"/>
                      </v-col>
                      <v-col cols="8" class="pl-3 pr-0" >
                        <div class="font16 bold mt-1">
                          <v-col class="pa-0 mb-2">{{ item2.name }}</v-col>
                          <v-col class="pl-0 pt-0 pb-0 mb-2 font12 icon2">{{ item2.endDate ? $t("message.useBefor") : $t("message.notHaveExpire")}} {{ item2.endDate ?  $i18n.locale === 'th' ? format_date_thai(item2.endDate.split(' ').slice(0, -1)) : format_date(item2.endDate.split(' ').slice(0, -1)).split(' ')[0] : ''}}</v-col>
                          <v-col class="pa-0 pr-3" v-if="item2.supply !== 'Discount'">
                            <!-- {{ format_date(today) > format_date(item.BvpExpieTim) }} -->
                            <!-- {{ new Date(today).getTime() < new Date(item.BvpExpieTim).getTime() }} -->
                            <v-btn
                                v-if="
                                new Date(momenDate_1(item2.endDate)).getTime() >
                                today.getTime() && item2.redeemStatus === 'get' && item2.supply !== 'coupon'
                                "
                                :color="$bgColor"
                                flat
                                title
                                small
                                elevation="0"
                                :class="['ma-0', $isTargetShop ? '' : 'bold']"
                                block
                                :style="(isTargetShop ? 'color:#000;border-radius:0px!important' : 'color:white')"
                                :disabled="shopId === shopNameData.bpv && new Date(today).getTime() > new Date(item.BvpExpieTime).getTime() &&  item.BvpExpieTime !== null"
                                @click="useReward(item2)"
                                >{{ $t("message.useReward") }}</v-btn>
                              <v-btn
                                v-if="
                                new Date(momenDate_1(item2.endDate)).getTime() >
                                  today.getTime() && item2.redeemStatus === 'use'
                                "
                                :color="$bgColor"
                                flat
                                title
                                small
                                :disabled="item2.rewardId === 1164 || item2.supply === 'รับหน้าร้าน'"
                                elevation="0"
                                :class="['ma-0', $isTargetShop ? '' : 'bold']"
                                block
                                :style="(isTargetShop ? 'color:#000;border-radius:0px!important' : 'color:white')"
                                @click="useReward(item2)"
                              >{{  item2.rewardId === 1164 ? $t("message.received") :  item2.supply === 'รับหน้าร้าน' ?  $t("message.received") : $t("message.openCode") }}
                              </v-btn>
                          </v-col>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card elevation="0" class="mt-4" :style="'border: solid 4px ' + $colorSub2 + ';border-radius: 10px;'" v-if="item.giveRewardStatus === 'False'">
                    <!-- <v-card-title class="headline text-center">
                      <img style=" border-color: white;height: 27px;margin-right: 3px;" :src="require('@/assets/black-friday.png')"/>
                    </v-card-title> -->
                    <v-card-text class="text-center">
                      <p class="mb-0" style="font-size: 16px;font-weight: bolder;">Coming Soon<img style=" border-color: white;height: 27px;margin-left: 7px;" :src="require('@/assets/black-friday.png')"/></p>
                      <p class="mb-0">เตรียมตัวให้พร้อม! </p>
                      <p>คูปองสุดพิเศษกำลังจะมาอีกมากมาย 🎉✨</p>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      </template>
    </div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="dialog && use">
        <v-toolbar dark :color="levelById.color">
          <v-btn icon dark @click="closeUseReward">
            <v-icon :color="HEXToVBColorLMG(levelById.color)">mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title dark ><span :style="'color:' + HEXToVBColorLMG(levelById.color)">Use Reward</span> </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list subheader>
          <v-subheader v-if="shopId !== 'SD_1737957295593'">{{ $t("message.showQrcodeReward") }}</v-subheader>
          <v-subheader v-if="shopId === 'SD_1737957295593' && use.supply !== 'รับหน้าร้าน'">{{ 'ใช้โค้ดด้านล่างเพื่อรับสิทธิพิเศษ' }}</v-subheader>
          <v-divider></v-divider>
        </v-list>
        <v-row>
          <v-col class="text-center">
            <qrcode-usecode
              :shopId="use.shopId"
              :rewardId="use.rewardId"
              :rewardCode="use.rewardCode"
              :supply="use.supply"
              :lineUserId="profile.userId"
            ></qrcode-usecode>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="text-center headline1 font20">
            {{ $t("message.rewardDetail") }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex flex-column justify-space-between align-center"
            ><v-img :src="use.pictureUrl" max-width="150"></v-img
          ></v-col>
        </v-row>
        <v-row class="font16 bold headline1">
          <v-col class="pl-0 pt-2" style="text-align: center;">{{ use.name }}</v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row v-if="use.description && ($i18n.locale === 'th' || use.descriptionEng === '' || use.descriptionEng === null)">
          <v-col class="icon2 font14 px-7" v-html="makeLinksClickable(use.description)"></v-col>
        </v-row>
        <v-row v-if="use.descriptionEng && $i18n.locale === 'en' && use.descriptionEng !== null">
            <v-col class="icon2 font14 px-7" v-html="makeLinksClickable(use.descriptionEng)"></v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="text-center">
            <v-row class="font14 icon2" >
              <v-col v-show="use.supply !=='coupon'" class="pl-0 pt-0 pb-3"
                >{{ $t("message.useBefor") }}
                <span class="icon1">{{ use.endDate }}</span></v-col
              >
              <v-col v-show="use.supply ==='coupon'" class="pl-0 pt-0 pb-3"
                >
                <span style="font-size: 1.15rem;" class="icon1">{{ use.remark }}</span></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogConfromLin"
      height="100"
      width="350"
    >
      <v-card>
        <v-card-title style="justify-content: center;">
          <span class="text-h6">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
              <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
            ยืนยันสิทธิ์เรียบร้อย
          </span>
        </v-card-title>
        <v-card-text class="pa-5 pt-2">
              <div>&emsp;คุณได้สิทธิ์ร่วมสนุกลุ้นรับรางวัล รายเอียดการร่วมกิจกรรมจะแจ้งผ่านทาง <v-icon class="iconify" data-icon="arcticons:line"></v-icon> "น้ำตาลพิญณุโลก LINE Official Account"</div>
        </v-card-text>
        <v-card-actions style="display:flex;justify-content: center">
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            block
            @click="checkRewardLin()"
          >
            รับทราบ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="otpDialog"
      persistent>
        <v-card>
          <v-toolbar
            :color="$colorSub2"
            dark
          ><div>{{ $t("message.otpAccept") }}</div><v-spacer></v-spacer><v-icon @click="otpDialog = false">mdi-close</v-icon></v-toolbar>
          <v-card-text class="text-h2 px-5" style="font-family: Kanit !important;">
            <p style="font-size: 15px;height: 33px;padding-left: 10px;" class="mb-0">{{ $t("message.waiting") }}</p>
            <div class="pa-1" style="display:flex;font-size: 15px"> <v-icon>mdi-cellphone-key</v-icon><p class="mb-0 mr-3">{{ $t("message.otpSentTo") }} </p> <p v-if="member" class="mb-0">{{ member.tel }}</p></div>
            <v-text-field
              v-model="otpPassword"
              class="mt-5"
              :label="`${this.$t('message.enterOtp')}`"
              maxlength="4"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
                  color="success"
                  @click="otpCheck"
                >{{ $t("message.confirm") }}</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogRewardBvp"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="dialogRewardBvp && dataReward">
        <v-toolbar dark :color="$bgColor2">
          <v-btn icon dark @click="closeDilogAndClearInterval">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Use Reward</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list subheader>
          <v-subheader>{{ $t("message.showBarcodeReward") }}</v-subheader>
          <v-divider></v-divider>
        </v-list>
        <v-row>
          <v-col class="text-center pb-0" cols="12">
            <span class="icon1" >กรุณาใช้ก่อนหมดเวลา</span>
          </v-col>
          <v-col class="text-center" cols="12">
            <span class="icon1" style="color:red !important; font-size: 19px !important;">{{ formattedTime.length === 5 ? formattedTime : formattedTime !== 'Expired' ? formattedTime : formattedTime}}</span>
            <barcode v-bind:value="dataReward.rewardCode" :width="barcodeWidth" style="display: flex;justify-content: center;" >
            </barcode>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="text-center headline1 font20">
            {{ $t("message.rewardDetail") }}
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="d-flex flex-column justify-space-between align-center"
            ><v-img :src="dataReward.pictureUrl" max-width="150"></v-img
          ></v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <v-row class="font16 bold headline1">
              <v-col class="pl-0 pt-2 pb-3">{{ dataReward.name }}</v-col>
            </v-row>
            <v-row class="font14 icon2" >
              <v-col v-show="dataReward.supply ==='coupon'" class="pl-0 pt-0 pb-3"
                >
                <span style="font-size: 1.15rem;" class="icon1">{{ dataReward.remark }}</span></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import QRCodeUserCode from '../../QRCodeUseCode.vue'
import axios from 'axios'
import VueBarcode from 'vue-barcode'
// import VueOtp2 from 'vue-otp-2'
export default {
  name: 'AllRewards',
  components: {
    'qrcode-usecode': QRCodeUserCode,
    'barcode': VueBarcode
  },
  data () {
    return {
      myPackage: null,
      dialogConfromLin: false,
      myPackageTransaxtion: null,
      member: null,
      profile: null,
      use: null,
      items: null,
      dialog: false,
      today: new Date(),
      tab: null,
      shopId: null,
      notExpire: 0,
      expire: 0,
      selected: '',
      otpDialog: false,
      myReward: [],
      BvpExpieTime: null,
      loadingbtn: false,
      formattedTime: '00:00',
      timer: '',
      otpPassword: '',
      dialogRewardBvp: false,
      barcodeWidth: 4,
      dataReward: null,
      rewardFromPackage: [],
      groupedData: null,
      levelById: null
      // columns2: [
      //   { text: 'ชื่อแพ็กเกจ', value: 'packageName' },
      //   { text: 'จำนวน', value: 'balanceAmount' },
      //   // { text: 'สาขา', value: 'balanceAmount' },
      //   { text: 'คะแนนที่ได้', value: 'packagePoint' },
      //   { text: 'เวลาที่ใช้', value: 'CREATE_DATE' }
      // ]
    }
  },
  computed: {
    isTargetShop () {
      return this.$isTargetShop()
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()
    await this.transactionVisitPage()
    await this.getReward()
    await this.getLevelById()
    // await this.getPackage()
    // await this.getPackageTransaction()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    makeLinksClickable (text) {
      // eslint-disable-next-line no-useless-escape
      const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
      const linkedText = text.replace(urlPattern, '<a href="$1" target="_blank">$1</a>')
      const textWithBreaks = linkedText.replace(/\n/g, '<br>')
      return textWithBreaks
    },
    async closeDilogAndClearInterval () {
      await this.getReward()
      this.dialogRewardBvp = false
      this.formattedTime = '00:00'
      clearInterval(this.timer)
    },
    startTimer (differenceInMinutes) {
      this.timer = setInterval(() => {
        differenceInMinutes--
        if (differenceInMinutes <= 0) {
          this.formattedTime = 'Expired'
          clearInterval(this.timer)
        } else {
          this.formattedTime = this.formatTime(differenceInMinutes)
        }
      }, 1000)
    },
    formatTime (seconds) {
      let minutes = Math.floor(seconds / 60)
      let remainingSeconds = seconds % 60
      let formattedSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds
      return `${minutes}:${formattedSeconds}`
    },
    async otpCheck () {
      try {
        const data = await axios.get(this.DNS_IP + `/otp/get?tel=${this.member.tel.trim()}`)
        if (data.data[0].otpPassword === this.otpPassword) {
          const data = await axios.post(this.DNS_IP + `/update/BvpExpieTime`, {'rewardId': this.dataReward.rewardId, 'shopId': this.shopId, 'rewardCodeId': this.dataReward.rewardCodeId})
          if (data.data.status === true) {
            await this.getReward()
            this.dataReward = this.myReward.filter(item => item.rewardCodeId === this.dataReward.rewardCodeId)[0]
            this.BvpExpieTime = this.dataReward.BvpExpieTime
            const now = new Date()
            const currentTime = new Date(now)
            const expiryTime = new Date(this.BvpExpieTime)
            const differenceInMs = expiryTime - currentTime
            const differenceInSeconds = Math.floor(differenceInMs / 1000)
            if (differenceInSeconds > 0) {
              this.startTimer(differenceInSeconds)
            } else {
            }
            this.otpDialog = false
            this.dialogRewardBvp = true
          }
        } else {
          this.otp = ''
          Swal.fire({
            title: '<h5>' + `ผิดพลาด OTP ไม่ถูกต้อง` + '</h5>',
            icon: 'error',
            showCancelButton: false,
            allowOutsideClick: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: `${this.$t('message.confirm')}`
          })
        }
      } catch (error) {
        console.error('dddd', error)
      }
    },
    handleOnComplete (value) {
    },
    arrayMove (arr, oldindex, newindex) {
      arr.splice(newindex, 0, arr.splice(oldindex, 1)[0])
      return arr
    },
    async checkRewardLin () {
      this.dialogConfromLin = false
      this.getReward()
    },
    async getPackage () {
      const result = await this.callBeTaskAPI(
        'get',
        `/PackageLog/get?userId=${this.profile.userId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.myPackage = result
      } else {
        this.myPackage = []
      }
    },
    async getReward () {
      this.items = []
      this.myReward = []
      this.rewardFromPackage = []
      this.notExpire = 0
      this.expire = 0
      let result = await this.callBeTaskAPI(
        'get',
        '/rewardCode/line/get?redeemStatus=get'
      )

      // console.log('test111', result.length)
      if (Array.isArray(result)) {
        this.items = result.sort(
          (a, b) => new Date(b.endDate) - new Date(a.endDate)
        )
        this.items.filter(item2 => !item2.idPackageLog).filter((item) => {
          if (item.endDate) {
            let endDate = new Date(this.momenDate_1(item.endDate)).getTime()
            if (endDate > this.today.getTime()) {
              this.notExpire += 1
              this.myReward.push(item)
            } else {
              this.expire += 1
            }
          } else {
            // alert('123')
            this.notExpire += 1
            this.myReward.push(item)
          }
        })

        // this.notExpire = this.items.filter((a) => new Date(this.momenDate_1(a.endDate)).getTime() > this.today.getTime()).length
        // this.expire = this.items.filter((a) => new Date(this.momenDate_1(a.endDate)).getTime() < this.today.getTime()).length
      }
      if (this.shopId === 'SD_1737957295593') {
        await this.RewardWithpackage()
      }
    },
    async RewardWithpackage () {
      let result2 = await this.callBeTaskAPI(
        'get',
        `/rewardCode/PackageReward/get?memberId=${this.profile.memberId}`
      )
      if (Array.isArray(result2)) {
        result2.sort(
          (a, b) => new Date(b.endDate) - new Date(a.endDate)
        )

        result2.filter((item) => {
          if (item.endDate) {
            let endDate = new Date(this.momenDate_1(item.endDate)).getTime()
            if (endDate > this.today.getTime()) {
              this.notExpire += 1
              this.rewardFromPackage.push(item)
            } else {
              if (item.redeemStatus !== 'use') {
                this.expire += 1
              }
            }
          } else {
            this.notExpire += 1
            this.rewardFromPackage.push(item)
          }
        })
      }
      this.groupedData = Object.values(
        this.rewardFromPackage.reduce((acc, item) => {
          if (!acc[item.idPackageLog]) {
            acc[item.idPackageLog] = {
              idPackageLog: item.idPackageLog,
              packageName: item.packageName,
              giveRewardStatus: item.giveRewardStatus,
              rewards: []
            }
          }
          acc[item.idPackageLog].rewards.push(item)
          return acc
        }, {})
      )

      // this.groupedData.map((item) => {
      //   console.log('tio', item.packageName)
      // })
    },
    async getPackageTransaction () {
      const result = await this.callBeTaskAPI(
        'get',
        `/PackageTransaction/get?userId=${this.profile.userId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.myPackageTransaxtion = result
      }
      // console.log(new Date(this.momenDate_1(result[0].endDate)).getTime())
    },
    async useReward (item) {
      this.dataReward = item
      if (item.rewardId === 338) {
        Swal.fire({
          title: 'ต้องการยืนยันสิทธิ์ใช่หรือไม่ ?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก',
          confirmButtonColor: '#3085d6'
        }).then(async (confirm) => {
          if (confirm.isConfirmed) {
            let dt = {
              'redeemStatus': 'use'
            }
            const result = await this.callBeTaskAPI(
              'post',
              `/update-confirm-lin/${item.rewardCodeId}`, dt
            )
            if (result) {
              this.dialogConfromLin = true
            }
          }
        })
      } else {
        if (this.shopId === this.shopNameData.bpv) {
          if (!item.BvpExpieTime) {
            Swal.fire({
              html: `<h5>หลังจากกดใช้ของรางวัล ต้องใช้ของรางวัลภายในเวลา <span style="color: red"">${item.BvpExpieMinAfterUse} นาที</span> ที่หน้าสาขา แนะนำให้กดใช้ของรางวัลเมื่ออยู่ที่สาขา<h5>`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'ยืนยันใช้ของรางวัล',
              cancelButtonText: 'ภายหลัง',
              confirmButtonColor: '#3085d6'
            }).then(async (confirm) => {
              if (confirm.isConfirmed) {
                this.BvpExpieTime = item.BvpExpieTime
                if (item.BvpExpieTime === null) {
                  // this.otpDialog = true
                  const result = await axios.post(this.DNS_IP + `/OTP/verifyReward`, {'tel': this.member.tel.trim(), 'shopId': this.shopId, 'language': this.$i18n.locale})
                  if (result.data.status === true) {
                    this.otpDialog = true
                  }
                } else {
                  const now = new Date()
                  const currentTime = new Date(now)
                  const expiryTime = new Date(this.BvpExpieTime)
                  const differenceInMs = expiryTime - currentTime
                  const differenceInSeconds = Math.floor(differenceInMs / 1000)
                  if (differenceInSeconds > 0) {
                    this.dialogRewardBvp = true
                    this.startTimer(differenceInSeconds)
                  } else {
                    // console.log('test', new Date(item.BvpExpieTime).getTime())
                  }
                }
              }
            })
          } else {
            this.BvpExpieTime = item.BvpExpieTime
            if (item.BvpExpieTime === null) {
              // this.otpDialog = true
              const result = await axios.post(this.DNS_IP + `/OTP/verifyReward`, {'tel': this.member.tel.trim(), 'shopId': this.shopId, 'language': this.$i18n.locale})
              if (result.data.status === true) {
                this.otpDialog = true
              }
            } else {
              const now = new Date()
              const currentTime = new Date(now)
              const expiryTime = new Date(this.BvpExpieTime)
              const differenceInMs = expiryTime - currentTime
              const differenceInSeconds = Math.floor(differenceInMs / 1000)
              if (differenceInSeconds > 0) {
                this.dialogRewardBvp = true
                this.startTimer(differenceInSeconds)
              } else {
                // console.log('test', new Date(item.BvpExpieTime).getTime())
              }
            }
          }
          // this.BvpExpieTime = item.BvpExpieTime
          // if (item.BvpExpieTime === null) {
          //   // this.otpDialog = true
          //   const result = await axios.post(this.DNS_IP + `/OTP/verifyReward`, {'tel': this.member.tel.trim(), 'shopId': this.shopId, 'language': this.$i18n.locale})
          //   if (result.data.status === true) {
          //     this.otpDialog = true
          //   }
          // } else {
          //   const now = new Date()
          //   const currentTime = new Date(now)
          //   const expiryTime = new Date(this.BvpExpieTime)
          //   const differenceInMs = expiryTime - currentTime
          //   const differenceInSeconds = Math.floor(differenceInMs / 1000)
          //   console.log(`Difference: ${differenceInSeconds} minutes`)
          //   if (differenceInSeconds > 0) {
          //     this.dialogRewardBvp = true
          //     this.startTimer(differenceInSeconds)
          //   } else {
          //     // console.log('test', new Date(item.BvpExpieTime).getTime())
          //     console.log('test', new Date(this.today).getTime() > new Date(item.BvpExpieTime).getTime())
          //     console.log('หมดเวลา')
          //   }
          // }
        } else {
          this.use = item
          this.dialog = true
        }
      }
    },
    closeUseReward () {
      this.myPackage = null
      this.getReward()
      this.dialog = false
    },
    async transactionVisitPage () {
      const result = await this.callBeTaskAPI(
        'post',
        `/TransactionVisitPage/add`, {
          page: 'Myreward',
          shopId: this.member.shopId,
          CREATE_USER: this.member.memberId
        }
      )
      if (result) {
      }
    },
    HEXToVBColorLMG (hex) {
      if (!hex) return '#E0E0E0'
      try {
        if (String(hex).toLowerCase().startsWith('#ffa300') || String(hex).toLowerCase().startsWith('#b3b3b3')) {
          return '#000000'
        }
        if (this.isWhiteTone(hex)) {
          return '#000000'
        }
      } catch (e) {
        // ignore and continue to fallback
      }

      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return '#E0E0E0'
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      if (brightness > 180) {
        return '#000' // สีเข้ม
      } else {
        return '#FFFFFF' // สีขาว
      }
    },
    normalizeHex (hex) {
      if (!hex) return null
      let h = String(hex).trim().toLowerCase()
      if (h.startsWith('rgb')) return null
      if (h[0] === '#') h = h.slice(1)
      if (h.length === 3) h = h.split('').map(c => c + c).join('')
      if (h.length !== 6) return null
      return h
    },
    isWhiteTone (color) {
      const h = this.normalizeHex(color)
      if (!h) return false
      const r = parseInt(h.slice(0, 2), 16)
      const g = parseInt(h.slice(2, 4), 16)
      const b = parseInt(h.slice(4, 6), 16)
      // perceived brightness
      const brightness = (r * 299 + g * 587 + b * 114) / 1000
      // threshold: very light colors considered 'white-tone'
      return brightness >= 240
    }
  }
}
</script>
<style scoped>
a.v-tab {
  text-decoration: none;
}
.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: #7ac142;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: 10% auto;
  box-shadow: inset 0px 0px 0px #7ac142;
  animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}
.blue-text {
    color: rgb(208, 57, 92);
}
.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}
.vue-otp-2 {
  display: flex;
  justify-content: space-between;

  div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      max-width: 60px !important;
      max-height: 60px !important;
      padding: 11.5px 8px;
      font-size: 20px;
      border-radius: 3px;
      border: 1px solid #cac9c9 !important;
      text-align: center;
    }

    span {
      display: block;
      flex: 1;
      text-align: center;
    }
  }
}
@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #7ac142;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Card/C/NewMyReward.vue